import './index.less';

import React, { useCallback } from 'react';

import { ArrowRight } from '@/components/Common/Icons';
import ResponsiveContent from '../ResponsiveContent';
import { useRouter } from 'next/router';

const FulfillmentBanner = ({ onFulfillment = false }: { onFulfillment?: boolean }) => {
  const router = useRouter();

  const goToFulfillment = useCallback(() => {
    router.push('/platform/logistics-and-fulfillment');
  }, [router]);

  const goToDemoSignup = useCallback(() => {
    router.push('/platform/logistics-and-fulfillment/signup');
  }, [router]);

  return (
    <div className="deal-banner" onClick={onFulfillment ? goToDemoSignup : goToFulfillment}>
      <div className="text-container">
        <div className="text">
          <ResponsiveContent
            set={[
              ['Move in & save 60%+ on fulfillment', 720],
              ['Cut fulfillment, shipping, and logistics costs by up to 60% with a Pietra membership'],
            ]}
          />
        </div>
      </div>
      <div className="cta">
        <ResponsiveContent
          set={[
            [null, 720],
            [
              <div className="text" key="deal-banner-cta-move-in">
                Move in
              </div>,
            ],
          ]}
        />
        <ArrowRight className="right-icon" />
      </div>
    </div>
  );
};

export default FulfillmentBanner;
